export const isBase64 = str => {
    if (str === "" || str.trim() === "") {
        return false;
    }
    try {
        const base64regex = /data:image\/([a-zA-Z]*);base64,([^"]*)/;
        return base64regex.test(str);
    } catch (err) {
        return false;
    }
};
